/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component, createRef } from "react";
import Label from "../../components/label";
import ICDateInput from "../../components/form/dateInput";
import ICButton from "../../components/button";
import PaymentSummaryList from "../../containers/PaymentSummaryList";
import MonthlySummaryModel from "../../containers/Models/MonthlyPaymentSummary";
import MakeAPICall from "../../apiCalls/common";
import moment from "moment";
import { getPaymentSummariesListNew } from "../../apiRoutes";
import { CSVLink } from "react-csv";
import html2pdf from "html2pdf.js";
import FullLogo from "../../assets/images/group-3@3x.png";
import WebLogo from "../../assets/images/earth.png";
import EmailLogo from "../../assets/images/mail-big.png";
import PhoneLogo from "../../assets/images/phone.png";
import { connect } from "react-redux";
import AvenirNextBoldEOT from "../../assets/fonts/AvriNextFont/avenir-next-bold.eot";
import AvenirNextBoldTTF from "../../assets/fonts/AvriNextFont/avenir-next-bold.ttf";
import AvenirNextBoldWOFF from "../../assets/fonts/AvriNextFont/avenir-next-bold.woff";
import AvenirNextRegularEOT from "../../assets/fonts/AvriNextFont/avenir-next-regular.eot";
import AvenirNextRegularTTF from "../../assets/fonts/AvriNextFont/avenir-next-regular.ttf";
import AvenirNextRegularWOFF from "../../assets/fonts/AvriNextFont/avenir-next-regular.woff";
import AvenirNextThinEOT from "../../assets/fonts/AvriNextFont/avenir-next-thin.eot";
import AvenirNextThinTTF from "../../assets/fonts/AvriNextFont/avenir-next-thin.ttf";
import AvenirNextThinWOFF from "../../assets/fonts/AvriNextFont/avenir-next-thin.woff";
import AvenirNextMediumEOT from "../../assets/fonts/AvriNextFont/AvenirLTPro-Medium.eot";
import AvenirNextMediumTTF from "../../assets/fonts/AvriNextFont/AvenirLTPro-Medium.ttf";
import AvenirNextMediumWOFF from "../../assets/fonts/AvriNextFont/AvenirLTPro-Medium.woff";
import Loader from "../../components/loader";
import ICIconBtn from "../../components/iconButton";

class PaymentSummaryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMonthlySummaryModel: false,
      apiCall: null,
      apiLoading: false,
      startDate: moment()
        .subtract(7, "days")
        .toISOString(),
      endDate: new Date().toISOString(),
      dateFilterApply: null,
      totalYears: [],
      monthlySummaryCSV: null,
      headers: [
        { label: "Payment Summary", key: "appointmentId" },
        { label: "Date", key: "createdAt" },
        { label: "Consult Cost", key: "appointmentPrice" },
        { label: "PM Fee", key: "PMFeeAmount" },
        { label: "GST On PM Fee", key: "taxAmount" },
        { label: "Earnings", key: "earnings" }
      ],
      data: [
        { firstname: "Ahmed", lastname: "Tomi", email: "ah@smthing.co.com" },
        { firstname: "Raed", lastname: "Labes", email: "rl@smthing.co.com" },
        { firstname: "Yezzi", lastname: "Min l3b", email: "ymin@cocococo.com" }
      ],
      doctorName:
        props.auth.userData.firstName + " " + props.auth.userData.lastName,
      abn: props.auth.userData.ABN,
      unitNumber:
        props.auth.userData.address && props.auth.userData.address.unitNumber
          ? props.auth.userData.address.unitNumber
          : "",
      streetNumber: props.auth.userData.address.streetNumber,
      streetName: props.auth.userData.address.streetName,
      suburb: props.auth.userData.address.suburb,
      state: props.auth.userData.address.state,
      postCode: props.auth.userData.address.postCode,
      doctorEmail: props.auth.userData.email,
      supportEmail: props.auth.appConstant.email,
      supportPhone: props.auth.appConstant.phoneNumber
        ? props.auth.appConstant.phoneNumber.slice(0, 4) +
          " " +
          props.auth.appConstant.phoneNumber.slice(4, 7) +
          " " +
          props.auth.appConstant.phoneNumber.slice(7)
        : "-",
      filterActive: true
    };
    this.csvInput = createRef();
  }

  downloadMonthlySummary = formValue => {
    this.setState({
      apiLoading: true
    });
    let startDate = moment([formValue.year, formValue.month - "1"]),
      endDate = moment(startDate).endOf("month");
    let paramData = {
      startDate: moment(startDate)
        .add(0, "d")
        .toISOString(),
      endDate: endDate.toISOString()
    };
    let apiCallParam = {
      reqType: "GET",
      reqURL: getPaymentSummariesListNew,
      dataObj: {},
      params: paramData,
      headers: {},
      successCallback: res => {
        let monthlySummaryDataFormat = [],
          totalConsultConst = 0,
          totalPMFee = 0,
          totalTax = 0,
          totalEarnings = 0,
          rows = "";
        res.data.data.paymentHistory.map((value, index) => {
          let earnings = (
              value.appointmentPrice +
              (value.isBulkIncentiveAdded !== undefined &&
              value.isBulkIncentiveAdded === true
                ? value.bulkIncentiveDetails.price
                : 0) -
              value.PMFeeAmount -
              value.taxAmount
            ).toFixed(2),
            createdAt = moment(value.createdAt).format("DD-MM-YYYY");

          totalConsultConst =
            totalConsultConst + Number(value.appointmentPrice);
          totalPMFee = totalPMFee + Number(value.PMFeeAmount);
          totalTax = totalTax + Number(value.taxAmount);
          totalEarnings = totalEarnings + Number(earnings);

          let appPrice = Number(value.appointmentPrice);

          if (
            value.isBulkIncentiveAdded !== undefined &&
            value.isBulkIncentiveAdded === true
          ) {
            totalConsultConst =
              totalConsultConst + value.bulkIncentiveDetails.price;
            appPrice = appPrice + value.bulkIncentiveDetails.price;
          }

          monthlySummaryDataFormat.push({
            appointmentId: value.appointmentId,
            createdAt: moment(value.createdAt).format("DD-MM-YYYY"),
            appointmentPrice: "$" + appPrice.toFixed(2),
            PMFeeAmount: "$" + value.PMFeeAmount.toFixed(2),
            taxAmount: "$" + value.taxAmount.toFixed(2),
            earnings: "$" + earnings
          });

          rows += "<tr>";
          rows +=
            "<td>" +
            value.appointmentId +
            "</td>" +
            "<td>" +
            createdAt +
            "</td>" +
            "<td> $ " +
            appPrice +
            "</td>" +
            "<td> $ " +
            value.PMFeeAmount +
            "</td>" +
            "<td> $ " +
            value.taxAmount +
            "</td>" +
            "<td> $ " +
            earnings +
            "</td>";
          rows += "</tr>";
        });
        if (formValue.csv) {
          monthlySummaryDataFormat.push({
            appointmentId: "-",
            createdAt: "-",
            appointmentPrice: "$" + totalConsultConst.toFixed(2),
            PMFeeAmount: "$" + totalPMFee.toFixed(2),
            taxAmount: "$" + totalTax.toFixed(2),
            earnings: "$" + totalEarnings.toFixed(2)
          });
          this.setState({
            monthlySummaryCSV: monthlySummaryDataFormat
          });
          document.querySelector("#downloadCSV").click(); // pure js to get the click event + ref is not working with CSVLink element
        }
        if (formValue.pdf) {
          let months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ];
          let element = this.generateHTMLCode(
            res.data.data.paymentHistory.length,
            months[+formValue.month - 1],
            formValue.year,
            this.state.doctorName,
            this.state.abn,
            this.state.unitNumber,
            this.state.streetNumber + " " + this.state.streetName,
            this.state.suburb,
            this.state.state,
            this.state.postCode,
            this.state.doctorEmail,
            rows,
            totalConsultConst,
            totalConsultConst,
            totalPMFee,
            totalTax,
            totalEarnings,
            this.state.supportEmail,
            this.state.supportPhone
          );
          // let element = this.generateHTMLCode(res.data.data.paymentHistory.length, months[(+formValue.month) - 1], formValue.year, this.state.doctorName, this.state.abn, this.state.unitNumber, this.state.streetNumber + " " + this.state.streetName, this.state.suburb, this.state.state, this.state.postCode, this.state.doctorEmail, rows, 2155, 2155, 5500, 55000, 1549, this.state.supportEmail, this.state.supportPhone);
          let docH = 350;
          let docW = 600;
          html2pdf(element, {
            margin: 1,
            filename: "MonthlySummary.pdf",
            image: { type: "jpeg", quality: 1 },
            html2canvas: { letterRendering: false, docH, docW, scale: 2 },
            jsPDF: { unit: "mm", format: [docH, docW], orientation: "l" }
          });
        }
        this.closeSummaryModal();
        this.setState({
          apiLoading: false
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  closeSummaryModal = () => {
    this.setState({ openMonthlySummaryModel: false });
  };

  openMonthlySummaryModel = () => {
    this.setState({ openMonthlySummaryModel: true });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  applyDateFilter = () => {
    this.setState({
      dateFilterApply: {
        startDate: this.state.startDate,
        endDate: this.state.endDate
      },
      filterActive: false
    });
    console.log("False now");
  };

  cancleFilterByDate = () => {
    let dataObj = {
      filterActive: true,
      startDate: new Date(
        moment()
          .subtract(7, "days")
          .format("MM/DD/YYYY")
      ).toISOString(),
      endDate: new Date().toISOString()
    };
    this.setState({
      filterActive: dataObj.filterActive,
      dateFilterApply: {
        startDate: dataObj.startDate,
        endDate: dataObj.endDate
      },
      startDate: dataObj.startDate,
      endDate: dataObj.endDate,
      filterByDateCall: !this.state.filterByDateCall
    });
  };

  generateHTMLCode = (
    arrLength,
    month,
    year,
    doctorName,
    abn,
    streetNumber,
    streetName,
    suburb,
    state,
    postCode,
    doctorEmail,
    tableRows,
    totalAmount,
    totalFee,
    PMFee,
    GST,
    totalEarning,
    supportEmail,
    supportPhone
  ) => {
    let paymentSlip = "";
    paymentSlip += "";
    paymentSlip += "<!DOCTYPE html>";
    paymentSlip += '<html lang="en">';
    paymentSlip += "<head>";
    paymentSlip += "        <title>Payment Summary Slip</title>";
    paymentSlip += '            <meta charset="utf-8">';
    paymentSlip +=
      '            <meta name="viewport" content="width=device-width, initial-scale=1">';
    paymentSlip +=
      '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">';
    paymentSlip +=
      '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">';
    paymentSlip +=
      '            <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.0/jquery.min.js"></script>';
    paymentSlip +=
      '            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>';
    paymentSlip += "            <style> body{padding:0px; margin:0px}";
    paymentSlip += "                @font-face {";
    paymentSlip += "        ";
    paymentSlip += "                    font-family: 'AvenirNextBold';";
    paymentSlip += "                    src: url('" + AvenirNextBoldEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextBoldEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextBoldWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextBoldTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextRegular';";
    paymentSlip +=
      "                    src: url('" + AvenirNextRegularEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextRegularEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextRegularWOFF +
      "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextRegularTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextThin';";
    paymentSlip += "                    src: url('" + AvenirNextThinEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextThinEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextThinWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextThinTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextMedium';";
    paymentSlip +=
      "                    src: url('" + AvenirNextMediumEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextMediumEOT +
      "?#iefix') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextMediumWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextMediumTTF +
      "') format('truetype');";
    paymentSlip += "                    font-weight: 500;";
    paymentSlip += "                    font-style: normal;";
    paymentSlip += "                }";
    paymentSlip += "                .class1 {";
    paymentSlip += "                    max-width: 100%;";
    paymentSlip += "                    width: 100%;";
    paymentSlip += "                    margin: 0 auto;";
    paymentSlip += "                    margin-top: 1%;";
    paymentSlip += "                    padding: 15px 30px;";
    paymentSlip += "                }";

    paymentSlip +=
      ".custom-tbl, .custom-tbl thead tr td, .custom-tbl tbody tr td, .custom-tbl tbody tr { border: 0}";

    paymentSlip += "            </style>";
    paymentSlip += "        </head>";
    paymentSlip += '        <body style="background-color: #f5f8f9;">';
    paymentSlip += '        <div class="container class1">';
    paymentSlip += '            <div class="row" >';
    paymentSlip +=
      '                <div class="col-sm-2 col-md-2 w-25 " style="text-align:left;padding:0px;overflow:hidden;">';
    paymentSlip +=
      '<img src="' +
      FullLogo +
      '" style="width:250px;height:auto;padding-bottom: 3px"  alt="logo"/>';
    // '
    // paymentSlip +=
    // '
    paymentSlip += "                </div>";
    paymentSlip +=
      '                <div class="col-sm-2 col-md-2 " style="text-align:right;padding:0px;">';
    paymentSlip +=
      '                    <div style="font-family:AvenirNextMedium; font-size:20px; color: black;font-weight: bold">';

    paymentSlip += "Payment Summary";

    paymentSlip += "                    </div>";
    paymentSlip +=
      '                    <div style="font-family:AvenirNextMedium; font-size:16px; color: black;padding-bottom: 20px">';

    paymentSlip += month + " " + year;

    paymentSlip += "                    </div>";
    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium; font-size:16px; font-weight: bold; top:16px; color: black;padding:0px;padding-top: 9px;padding-bottom: 0px">';
    paymentSlip += "                    Instant Consult";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium; font-size:16px; color: black;padding:0px;padding-top: 16px;">';

    paymentSlip += "Dr. " + doctorName;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular;top:14px; font-size:16px;color: black;padding-bottom:0px;padding:0px">';
    paymentSlip += "                    ACN: 617 811 337";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family: AvenirNextRegular; font-size:16px;color: black;padding-bottom:3px;padding:0px">';

    paymentSlip +=
      "ABN: " +
      abn.substring(0, 2) +
      " " +
      abn.substring(2, 5) +
      " " +
      abn.substring(5, 8) +
      " " +
      abn.substring(8, 11);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;top:15px;padding-top:5px; padding-left:0px">';
    paymentSlip +=
      '<img src="' +
      PhoneLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" />&nbsp;&nbsp;&nbsp;' +
      supportPhone;
    // '                    <i class="fas fa-phone-alt" style="color:black !important;" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;' + supportPhone;
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextRegular; font-size:16px; color: black;padding:0px;text-transform: capitalize;">';

    paymentSlip +=
      streetNumber +
      " " +
      streetName +
      " <br/>" +
      suburb +
      " " +
      state +
      " " +
      postCode;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="position:relative;text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;padding:0px">';
    paymentSlip +=
      '<img src="' +
      EmailLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" />';
    // '                    <i class="fa fa-envelope" style="color:black !important; margin-right: 3px" aria-hidden="true"></i>&nbsp;';
    paymentSlip +=
      "&nbsp;&nbsp;&nbsp;<span style='position: absolute; top:0; left: 33px;'>" +
      supportEmail;
    paymentSlip += "                </span></div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size:16px;color: rgb(245,171,53) !important;padding:0px;padding-top:3px;">';

    paymentSlip += doctorEmail;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip +=
      '                <div class="col-sm-12 col-lg-12 col-xs-12 col-md-12 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;padding:0px">';
    paymentSlip +=
      '<img src="' +
      WebLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" /> &nbsp;&nbsp;&nbsp;instantconsult.com.au';
    // '                    <i class="fa fa-globe" style="color:black !important;" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;instantconsult.com.au';
    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:15px;">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color:black; padding-bottom:5px;padding:0px">';

    paymentSlip +=
      "                    Consultation Cost - " + month + " " + year;

    paymentSlip += "                </div>";

    paymentSlip += '                <div class="col-sm-2 col-md-2 rightRow"';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (totalAmount).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(totalAmount)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";

    paymentSlip += '            <div class="row" style="padding-top:5px">';
    paymentSlip += '                <div class="col-sm-2 col-md-2"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align: left;font-family:AvenirNextMedium;letter-spacing:0.1px;font-size: 16px;font-weight:500;color: black;padding:0px">';
    paymentSlip += "                    Total Fee";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2"';
    paymentSlip +=
      '                     style="background-color:rgb(245,245,245) !important;text-align:right;font-family: AvenirNextMedium;font-size: 16px;font-weight:500;color: black;padding:0px">';

    // paymentSlip += '$' + (totalFee).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(totalFee)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:5px">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';
    paymentSlip += "                    Practice Management Fee";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (PMFee).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(PMFee)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:5px">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';
    paymentSlip += "                    GST on Practice Management Fee";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (GST).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(GST)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:5px;">';
    paymentSlip += '                <div class="col-sm-2 col-md-2"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align:left;font-family:AvenirNextMedium;font-size: 18px;font-weight: bold;color: black;padding:0px">';
    paymentSlip += "                    Total Earnings";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 rightRow"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align:right;font-family:AvenirNextMedium;font-size: 18px;font-weight: bold;color: black;padding:0px">';

    // paymentSlip += '$' + (totalEarning).toLocaleString(undefined, {maximumFractionDigits:2});
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(totalEarning)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += "        </div>";
    paymentSlip += "        </body>";
    paymentSlip += "        </html>";

    return paymentSlip;
  };

  render() {
    return (
      <div className="row rounded p-3 payment-summary-page">
        {/* Top Filters */}
        <div className="col-sm-5 p-3">
          <Label title="Payment Summaries" className="big" />
        </div>
        <div className="col-sm-12"></div>
        <div className="col-sm-3 pt-2">
          <ICDateInput
            id="startdate"
            name="startdate"
            className="cal-primary-bg"
            label=""
            defaultDate={this.state.startDate}
            handleChange={date =>
              this.setState({ startDate: date, filterActive: true })
            }
            filterOn={this.state.startDate}
          />
        </div>
        <div className="col-sm-3 pt-2">
          <ICDateInput
            id="enddate"
            name="enddate"
            className="cal-primary-bg"
            label=""
            defaultDate={this.state.endDate}
            handleChange={date =>
              this.setState({ endDate: date, filterActive: true })
            }
            filterOn={this.state.endDate}
          />
        </div>
        <div className="col-sm-6 pt-0">
          {/* <ICButton title="Apply Filter" type="button" clickEvent={this.applyDateFilter} /> */}
          <ICIconBtn
            title=""
            className={this.state.filterActive ? "font-15 only-icon" : "d-none"}
            type="button"
            clickEvent={this.applyDateFilter}
            icon="fas fa-arrow-right"
          />

          <ICIconBtn
            title=""
            className={
              !this.state.filterActive ? "font-15 only-icon danger" : "d-none"
            }
            type="button"
            clickEvent={this.cancleFilterByDate}
            icon="fas fa-times"
          />

          <ICButton
            title="Monthly Summary"
            type="button"
            className="ml-4"
            clickEvent={this.openMonthlySummaryModel}
          />
        </div>
        <div className="col-sm-12 border-bottom mt-3"></div>

        <div className="col-sm-12 mt-4">
          <PaymentSummaryList
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            makeAPICall={this.componentAPICall}
            dateFilterApply={this.state.dateFilterApply}
          />
        </div>

        <MonthlySummaryModel
          openModal={this.state.openMonthlySummaryModel}
          okayText="Okay"
          cancelText="Cancel"
          title="Export Monthly Summary Report"
          useOneButton={false}
          onFormSubmit={this.downloadMonthlySummary}
          cancelEvent={this.closeSummaryModal}
        />
        {/* <CSVLink  ref={this.csvInput} filename={"Monthly_Summary.csv"} className="d-none" data={this.state.data} headers={this.state.headers}> Download me </CSVLink> */}

        {this.state.monthlySummaryCSV && this.state.monthlySummaryCSV.length ? (
          <CSVLink
            id="downloadCSV"
            ref={input => (this.csvInput = input)}
            filename={"Monthly_Summary.csv"}
            className="d-none"
            data={this.state.monthlySummaryCSV}
            headers={this.state.headers}
          >
            {" "}
            Download me{" "}
          </CSVLink>
        ) : (
          ""
        )}

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Loader */}
        <Loader loading={this.state.apiLoading} />
      </div>
    );
  }
}

// export default PaymentSummaryPage;

const mapStateToProps = props => ({
  auth: props.auth.user
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSummaryPage);
